"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
var _excluded = ["classes", "children", "dataMetrics", "direction"],
  _excluded2 = ["root"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    layoutCol: {
      flexDirection: 'column'
    },
    layoutRow: {
      flexDirection: 'row'
    }
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_radio_group'
  },
  direction: 'col'
};

/**
 * RadioGroup is a helpful wrapper used to group Radio components that provides an easier API, and proper keyboard accessibility to the group.
 */
var RadioGroup = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _cx;
  var _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {} : _ref$classes,
    children = _ref.children,
    dataMetrics = _ref.dataMetrics,
    direction = _ref.direction,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var styleClasses = useStyles();
  var classesRoot = classes.root,
    restClasses = (0, _objectWithoutProperties2["default"])(classes, _excluded2);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], (0, _extends2["default"])({
    classes: _objectSpread({
      root: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, classesRoot, !!classesRoot), (0, _defineProperty2["default"])(_cx, styleClasses.layoutCol, direction === 'col'), (0, _defineProperty2["default"])(_cx, styleClasses.layoutRow, direction === 'row'), _cx))
    }, restClasses),
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, rest), _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].isValidElement(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
      row: direction === 'row'
    }) : child;
  }));
});
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = defaultProps;
RadioGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  classes: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Radio Layout direction
   */
  direction: _propTypes["default"].oneOf(['row', 'col']),
  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes["default"].string,
  /**
   * @ignore
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes["default"].func,
  /**
   * Value of the selected radio button.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool])
} : {};
var _default = RadioGroup;
exports["default"] = _default;